<template>
  <div>
    <b-table
      :fields="fields"
      :items="$store.getters.accountsLog"
      sort-icon-left
      data-checkbox="true"
      sticky-header
      head-variant="dark"
      hover
      small
      striped
    >
    </b-table>
    <tableListNoData
      v-if="$store.getters.accountsLog.length === 0"
    ></tableListNoData>
  </div>
</template>

<script>
import tableListNoData from "@/components/TableListNoData.vue";
export default {
  components: {
    tableListNoData
  },
  data() {
    return {
      fields: [
        { key: "last_login_at", label: "登入時間", sortable: true },
        { key: "account", label: "帳號", sortable: true },
        { key: "name", label: "姓名", sortable: true }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
